import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Users } from "lucide-react";

export function LeadsTab({ leads }) {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="font-bold">Leads Capturados</h2>
        <Badge variant="outline">{leads.length} leads</Badge>
      </div>
      <ScrollArea className="h-[65vh]">
        <div className="space-y-2">
          {leads.map((l, i) => (
            <Card key={i} data-testid={`admin-lead-${i}`}>
              <CardContent className="p-3 flex items-center gap-3">
                <div className="flex-1 min-w-0">
                  <p className="font-bold text-sm">{l.name || l.contact || "Lead"}</p>
                  <p className="text-xs text-muted-foreground">{l.contact} | {l.interest}</p>
                </div>
                <Badge variant="outline" className="text-[10px]">{l.source || "chatbot"}</Badge>
                <p className="text-[10px] text-muted-foreground">
                  {l.created_at ? new Date(l.created_at).toLocaleDateString() : ""}
                </p>
              </CardContent>
            </Card>
          ))}
          {leads.length === 0 && (
            <Card>
              <CardContent className="p-8 text-center text-muted-foreground">
                <Users className="w-10 h-10 mx-auto mb-2 opacity-30" />
                <p>Nenhum lead capturado ainda</p>
              </CardContent>
            </Card>
          )}
        </div>
      </ScrollArea>
    </div>
  );
}
